import { render, staticRenderFns } from "./LegendViewTemplate.vue?vue&type=template&id=6f34de68&"
import script from "./LegendViewTemplate.vue?vue&type=script&lang=js&"
export * from "./LegendViewTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports